import React from 'react'
import PropTypes from 'prop-types'
import { Layout, Menu } from 'antd'
import { Link } from 'react-router-dom'

const { Header } = Layout
const { SubMenu } = Menu

const Navbar = props => (
  <Header style={{ background: '#fff', borderBottom: '1px solid #e8e8e8' }}>
    <div style={{ float: 'left', height: '64px', fontSize: '18px' }}>
      <img src="/images/logo.png" alt="Logo" style={{ height: '36px', marginRight: '10px' }} />
    </div>
    <Menu
      mode="horizontal"
      defaultSelectedKeys={[props.selected]}
      style={{ lineHeight: '62px', float: 'right' }}
    >
      <SubMenu title="Search">
      <Menu.Item key="search:7">
          <Link to="/search/events">Search Event [Race]</Link>
        </Menu.Item>
      <Menu.Item key="search:6">
          <Link to="/search/bibs">Search Bib [Race]</Link>
        </Menu.Item>
        <Menu.Item key="search:5">
          <Link to="/search/orderids">Search OrderID [Shop]</Link>
        </Menu.Item>
      <Menu.Item key="search:1">
          <Link to="/search/recipients">Search Recipients</Link>
        </Menu.Item>
        <Menu.Item key="search:2">
          <Link to="/search/trackings">Search Trackings</Link>
        </Menu.Item>
        <Menu.Item key="search:3">
          <Link to="/search/labels">Search Labels</Link>
        </Menu.Item>        
        <Menu.Item key="search:4">
          <Link to="/search/items">Search Items</Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu title="Label">
        <Menu.Item key="label:2">
          <Link to="/labels">Thaipost Labels</Link>
        </Menu.Item>        
        <Menu.Item key="label:3">
          <Link to="/flashLabels">Flash Labels</Link>
        </Menu.Item>
        {/* <Menu.Item key="label:1">
          <Link to="/kerryLabels">Kerry Labels</Link>
        </Menu.Item> */}
        {/* <Menu.Item key="label:3">
          <Link to="/trackingjandts">J&T Lables</Link>
        </Menu.Item> */}
        <Menu.Item key="label:4">
          <Link to="/labelgroupall">All Labels</Link>
        </Menu.Item>
        <Menu.Item key="label:5">
          <Link to="/labelSummary">Label Summary</Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu title="Import">
        <Menu.Item key="import:1">
        <Link to="/importLabel">Import Label</Link>
        </Menu.Item>
        <Menu.Item key="import:2">
        <Link to="/importTracking">Import Tracking</Link>
        </Menu.Item>
        <Menu.Item key="import:3">
        <Link to="/sendtrackingbyfile">Send Tracking By File</Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu title="Product">
        <Menu.Item key="product:1">
          <Link to="/products">All Products</Link>
        </Menu.Item>
        <Menu.Item key="product:2">
          <Link to="/addProduct">Add Product</Link>
        </Menu.Item>
        <Menu.Item key="product:5">
          <Link to="/raceProduct">Race Product</Link>
        </Menu.Item>
        <Menu.Item key="product:3">
          <Link to="/item">Gen Item Label</Link>
        </Menu.Item>
        <Menu.Item key="product:4">
          <Link to="/checkout">Check-out Items</Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu title="User">
        <Menu.Item key="user:1">
          <Link to="/users">All Users</Link>
        </Menu.Item>
        <Menu.Item key="user:2">
          <Link to="/addUser">Add User</Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu title="Sell">
        <Menu.Item key="sell:1">
          <Link to="/sell/items">Items</Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu title="Report">
        <Menu.Item key="report:1">
          <Link to="/reportTracking">Report Tracking</Link>
        </Menu.Item>
      </SubMenu>
    </Menu>
  </Header>
)

Navbar.propTypes = {
  selected: PropTypes.string.isRequired,
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js